var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSepolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3745 2.99829V9.65111L17.9975 12.164L12.3745 2.99829Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3744 2.99829L6.75146 12.164L12.3744 9.65111V2.99829Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3745 16.4743V20.9948L18.0008 13.2102L12.3745 16.4743Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3744 20.9948V16.4743L6.75146 13.2102L12.3744 20.9948Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3745 15.4283L17.9975 12.1642L12.3745 9.65137V15.4283Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75146 12.1642L12.3744 15.4283V9.65137L6.75146 12.1642Z",
    fill: "white",
    fillOpacity: 0.602
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepolia);
export default __webpack_public_path__ + "static/media/sepolia.ac47aa43786853f78d36c1c0582f68db.svg";
export { ForwardRef as ReactComponent };